import React from "react";
import { Map, Sprout, Brain, House, ArrowRight, Instagram, Repeat, Monitor, Bot, Target, Lightbulb } from "lucide-react";
import { Link } from "@/components/common/Link";
import { Card, CardContent, CardHeader, CardTitle, CardDescription, CardFooter } from "@/components/ui/card";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
import { cn } from "@/lib/utils";
const services = [{
  title: "Social Media Beheer",
  description: "Versterk je online aanwezigheid op social media zodat klanten jou vinden, met social media content die verbindt en converteert.",
  icon: Instagram,
  href: "/ServicesPage"
}, {
  title: "Automatiseringen",
  description: "Win kostbare tijd terug door taken slim te automatiseren zodat jij kunt focussen op de groei van je onderneming.",
  icon: Repeat,
  href: "/ServicesPage"
}, {
  title: "AI-gedreven Websites",
  description: "Een website die niet alleen modern is, maar ook werkt. Gevonden door de juiste mensen en gebouwd om bezoekers om te zetten in klanten.",
  icon: Monitor,
  href: "/ServicesPage"
}, {
  title: "AI-Chatbots",
  description: "Geen tijd meer kwijt aan herhalende vragen en administratie. Een slimme chatbot regelt het zodat jij je aandacht geeft aan de klanten die ertoe doen.",
  icon: Bot,
  href: "/ServicesPage"
}, {
  title: "Online Adverteren",
  description: "Bereik je ideale doelgroep op het juiste moment met Google en Meta campagnes die meetbare resultaten en groei opleveren.",
  icon: Target,
  href: "/ServicesPage"
}, {
  title: "Strategisch Advies",
  description: "Staat jouw oplossing er niet tussen? Samen zoeken we naar wat\xA0 bij jouw onderneming past.",
  icon: Lightbulb,
  href: "/ServicesPage"
}];
export default function OnzeWegwijzers() {
  const {
    ref,
    isVisible
  } = useRevealOnScroll({
    threshold: 0.1
  });
  return <section data-section-id="62362" id="expertise-in-detail" className="text-foreground py-20 relative overflow-hidden !bg-[hsl(20,100%,98%)]">
      <div className="absolute top-0 left-0 w-full h-full overflow-hidden pointer-events-none">
        <div className="absolute top-[-10%] right-[-5%] w-96 h-96 bg-accent/5 rounded-full blur-3xl" />
        <div className="absolute bottom-[-10%] left-[-5%] w-96 h-96 bg-primary/5 rounded-full blur-3xl" />
      </div>

      <div className="container mx-auto px-4 relative z-10">
        <div ref={ref} className={cn("transition-all duration-1000 ease-out", isVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-10")}>
          <div className="text-center mb-16 max-w-2xl mx-auto">
            <h2 className="text-4xl md:text-5xl font-default font-bold mb-4 tracking-tight text-primary">Onze groeipijlers</h2>
            <p className="text-muted-foreground font-sans text-xl leading-relaxed !font-light">Elke groeivraag is anders en vraagt maatwerk. Als je alle losse onderdelen binnen online marketing goed op elkaar afstemt, dan versterken ze elkaar. Neem een kijkje en zie wat wij kunnen betekenen.</p>
          </div>

          <div className="grid grid-cols-1 md:grid-cols-2 gap-6 lg:gap-8 max-w-5xl mx-auto">
            {services.map((service, i) => <div key={i} data-index={i} className="group h-full">
                <Card className="h-full border-border/50 bg-card/60 backdrop-blur-md transition-all duration-300 hover:bg-white/90 hover:border-accent/30 shadow-[0_8px_30px_rgb(0,0,0,0.04)] hover:shadow-xl hover:shadow-accent/5 group-hover:-translate-y-1">
                  <CardHeader className="items-center text-center pb-2">
                    <div className="mb-4 p-4 rounded-full bg-accent/10 text-accent-foreground ring-1 ring-accent/20 group-hover:bg-accent/20 group-hover:scale-110 transition-all duration-300">
                      <service.icon className="w-8 h-8" strokeWidth={1.5} />
                    </div>
                    <CardTitle className="text-xl font-default font-semibold text-foreground group-hover:text-accent-foreground transition-colors">
                      {service.title}
                    </CardTitle>
                  </CardHeader>
                  <CardContent className="text-center px-6">
                    <CardDescription className="text-muted-foreground font-sans text-base leading-relaxed line-clamp-3">
                      {service.description}
                    </CardDescription>
                  </CardContent>
                  <CardFooter className="justify-center pb-8 pt-2">
                    <Link to="/Contact" className="inline-flex items-center text-sm font-sans font-medium text-accent-foreground hover:text-primary transition-colors group/link">
                      Ontdek meer
                      <ArrowRight className="ml-2 w-4 h-4 transition-transform duration-300 group-hover/link:translate-x-1" />
                    </Link>
                  </CardFooter>
                </Card>
              </div>)}
          </div>
        </div>
      </div>
    </section>;
}